import React from 'react';
import PropTypes from 'prop-types';
import { Section } from '..';
import { checkSectionCondition } from '../../Form.helpers';

const ContactDataFull = ({ form, translations }) => {
    const data = form.fullContactData;
    const { streetName, houseNumber, apartmentNumber, city, zipCode, country, region } = data;

    const dataArray = [
        streetName,
        houseNumber,
        apartmentNumber,
        city,
        zipCode,
        country,
        region
    ];

    const renderedSection = checkSectionCondition(dataArray);

    return (
        <>
            <Section.Conditional
                condition={Boolean(data.order) && renderedSection}
                title={translations.shortContactData}
            >
                {({ renderField }) => (
                    <>
                        {renderField(translations.streetName, streetName)}
                        {renderField(translations.houseNumber, houseNumber)}
                        {renderField(translations.apartmentNumber, apartmentNumber)}
                        {renderField(translations.city, city)}
                        {renderField(translations.zipCode, zipCode)}
                        {renderField(translations.country, country)}
                        {renderField(translations.region, region)}
                    </>
                )}
            </Section.Conditional>
        </>
    );
};
ContactDataFull.propTypes = {
    form: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default ContactDataFull;
